import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import logo from "../../Assets/logo.png";
import vid from '../../Assets/video-editing.png'

import mobilecard from '../../Assets/card-mobile.png'
import { Link } from "react-router-dom";

import ReactDOM from "react-dom";

function Services() {
  return (
    <div>
       return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        
      <h1 className="heading-name" style={{ justifyContent: "center", marginTop: "100px" }}>
      
                <strong className="main-name">Our Services</strong>
                
              </h1>
              <h1 className="heading-name" style={{ justifyContent: "center", marginTop: "10px" }}>
      
               
                <strong className="main-name">ኣገልግሎትና</strong>
              </h1>
      <Row style={{ justifyContent: "center", marginTop: "5px" }}>
      <div class="ag-format-container">
  <div class="ag-courses_box">
   

  <div class="ag-courses_item">
      <Link to='/serviceform' style={{textDecoration: 'none'}} className='ag-courses-item_link'>
        <div class="ag-courses-item_bg ">
        </div>
        <div class="ag-courses-item_title">
         <h3>Mobile App </h3> 
          ሞባይል ኣፕ
        </div>
    
      </Link>
    </div>
      
  <div class="ag-courses_item">
      <Link to='/serviceform' style={{textDecoration: 'none'}} className='ag-courses-item_link'>
        <div class="ag-courses-item_bg ">
        </div>
        <div class="ag-courses-item_title">
          Web Design  
          ዌብሳይት ምስራሕ
        </div>
    
      </Link>
    </div>

  <div class="ag-courses_item">
      <Link to='/serviceform' style={{textDecoration: 'none'}} className='ag-courses-item_link'>
        <div class="ag-courses-item_bg ">
        </div>
        <div class="ag-courses-item_title">
         Logo Design"  &#160;
          ሎጎ ዲዛይን
        </div>
    
      </Link>
    </div>
   <div class="ag-courses_item">
      <Link to='/serviceform' style={{textDecoration: 'none'}} className='ag-courses-item_link'>
        <div class="ag-courses-item_bg ">
        </div>
        <div class="ag-courses-item_title">
          Graphic Design"  &#160;
          ግራፊክ ዲዛይን
        </div>
    
      </Link>
    </div>

     <div class="ag-courses_item">
      <Link to='/serviceform' style={{textDecoration: 'none'}} className='ag-courses-item_link'>
        <div class="ag-courses-item_bg ">
        </div>
        <div class="ag-courses-item_title">
          Video editing"  &#160;
          ቪድዮ ምቅንባር
        </div>
    
      </Link>
    </div>

      <div class="ag-courses_item">
      <Link to='/serviceform' style={{textDecoration: 'none'}} className='ag-courses-item_link'>
        <div class="ag-courses-item_bg ">
        </div>
        <div class="ag-courses-item_title">
          Data Analysis"  &#160;
          ምሕደራ ዳታ 
        </div>
    
      </Link>
    </div>

  </div>
</div>
    </Row>
      </Container>
    </Container>
  );

    </div>
  )
}

export default Services
